<template>
  <div class="container">
    <pcTabBarComponent tabBarKey="user" />
    <pcUserNavComponent tabBarKey="contact">
      <div class="page-container">
        <div class="page-title-item">
          <div class="title-item active">密钥管理</div>
        </div>
        <div class="page-content-item">
          <div class="column-item">
            <div class="title-item">AppId：</div>
            <div class="detail-item">
              <div class="value">{{ userInfo.AppId }}</div>
              <div class="btn public-btn" @click="handleCopy(userInfo.AppId)">复制</div>
            </div>
          </div>
          <div class="column-item">
            <div class="title-item">AppSecret：</div>
            <div class="detail-item">
              <div class="value">{{ userInfo.AppSecret }}</div>
              <div class="btn public-btn" @click="handleCopy(userInfo.AppSecret)">复制</div>
            </div>
          </div>
          <div class="flex-1"></div>
          <div class="submit-btn public-btn" @click="handleShowResetPopup">重置密钥</div>
        </div>
      </div>
    </pcUserNavComponent>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import pcTabBarComponent from '@/components/pcTabBarComponent'
import pcUserNavComponent from '@/components/pcUserNavComponent'

export default {
  name: "Contact",
  components: {
    pcTabBarComponent,
    pcUserNavComponent
  },
  data() {
    return {
      submiting: false
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  mounted() {
    
  },
  methods: {
    ...mapActions(['GetUserInfo']),
    handleCopy(text) {
      this.$copyText(`${text}`).then(() => {
        this.$toast('复制成功')
      }).catch(() => {
        this.$toast('复制失败')
      })
    },
    handleShowResetPopup() {
      this.$dialog.confirm({
        type: 'info',
        className: 'pc-dialog',
        title: '提示',
        message: '确定要重置密钥吗？',
        cancelButtonText: '取消',
        confirmButtonText: '确认',
      }).then(() => {
        this.handleSubmit()
      }).catch(() => {
      })
    },
    async handleSubmit() {
      const { userInfo } = this
      this.submiting = true
      var res = await this.$API.resetKey.post({
        AppId: userInfo.AppId,
        AccessKeyId: userInfo.AppSecret,
      })
      this.submiting = false
      if(res.error == 0){
        this.$toast.success(res.info)
        this.GetUserInfo()
      } else {
        this.$dialog.alert({
          type: 'danger',
          title: '提示',
          message: res.info,
          confirmButtonText: '确定',
        })
        return false
      }
      this.showResetPopup = false
    }
  },
}

</script>

<style lang="less" scoped>
.page-container {
  background-color: #fff;
  border-radius: 5px;
  padding: 0 15px 15px;
  overflow: hidden;
}
.page-title-item {
  padding-top: 10px;
  border-bottom: 1px solid #e5e5e5;
  .title-item {
    width: 112px;
    line-height: 48px;
    text-align: center;
    border-bottom: 2px solid transparent;
    color: #64748b;
    font-size: 18px;
    &.active {
      border-bottom-color: #5783fc;
      color: #5783fc;
    }
  }
}
.page-content-item {
  padding: 20px;
  background-color: #f8f8f8;
  .column-item {
    margin-bottom: 20px;
    padding: 16px 0;
    font-size: 14px;
    color: #242941;
    .title-item {
      line-height: 20px;
    }
    .detail-item {
      margin-top: 10px;
      width: 540px;
      height: 44px;
      background-color: #fff;
      border-radius: 12px;
      box-sizing: border-box;
      padding: 0 8px 0 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .value {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .btn {
        cursor: pointer;
        margin-left: 14px;
        width: 48px;
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        color: #fff;
        font-weight: 500;
        font-size: 12px;
      }
    }
  }
  .submit-btn {
    cursor: pointer;
    width: 240px;
    height: 44px;
    border-radius: 12px;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>